<template>
    <a-modal v-model:visible="modalConfig.visible" :title="modalConfig.title" @ok="handleOk" @cancel="handleCancel">
        <a-form ref="formRef" :model="formState" :rules="rules" :label-col="{ style: { width: '110px' } }"
            :wrapper-col="{ style: { width: '300px' } }">
            <template v-if="modalConfig.role === 'afterSales'">
                <a-form-item label="年度" name="year">
                    <a-input v-model:value="formState.year" placeholder="年度" allowClear
                        :disabled="statusLimit"></a-input>
                </a-form-item>

                <a-form-item label="生产日期" name="produceDate">
                    <a-date-picker v-model:value="formState.produceDate"
                        @change="(e, stringTime) => formState.produceDate = stringTime" placeholder="生产日期"
                        :disabled="statusLimit" allowClear></a-date-picker>
                </a-form-item>

                <a-form-item label="设备型号" name="model">
                    <series-type-cascader type="machineOptions" placeholder="请选择设备型号" :source="formState"
                        :disabled="statusLimit" :target="['serialType', 'model']"></series-type-cascader>
                </a-form-item>

                <a-form-item label="机身号" name="serial">
                    <a-input v-model:value="formState.serial" placeholder="请输入机身号" :disabled="statusLimit"
                        allowClear></a-input>
                </a-form-item>

                <a-form-item label="状态" name="status">
                    <a-select v-model:value="formState.status" :options="afterSaleOptions" allowClear
                        placeholder="请选择状态" :disabled="afterSaleStatusLimit">
                    </a-select>
                </a-form-item>

                <a-form-item label="临时措施" name="temporaryMeasures" v-if="formState.status === '现场维修'">
                    <a-textarea v-model:value="formState.temporaryMeasures" :auto-size="{ minRows: 1, maxRows: 10 }"
                        placeholder="临时措施" allowClear></a-textarea>
                </a-form-item>

                <a-form-item label="问题现象" name="problemPhenomenon">
                    <after-sale-qeustion-vue :questionLists="formState.problemPhenomenon" :disabled="statusLimit"
                        textAreaStyle="width: 320px" ref="questionRef"></after-sale-qeustion-vue>
                </a-form-item>

                <!-- <a-form-item label="问题类型" name="problemType" v-if="formState.status === '现场维修'">
                    <a-select v-model:value="formState.problemType" :options="questionTypeOptions" allowClear
                        placeholder="请选择问题类型">
                    </a-select>
                </a-form-item> -->


                <!-- <a-form-item label="通知人">
                    <staff :echoStaff="formState.recipient ? formState.recipient.split(',')[1] : null"
                        :echostaffUserName="formState.recipient ? formState.recipient.split(',')[0] : null"
                        @getChooseStaff="getChooseStaff($event, 'recipient')" :disabled="statusLimit"
                        :appointDepartment="['工程部', '试产中心']"></staff>
                </a-form-item> -->

                <!-- <a-form-item label="通知消息" v-if="useNotice">
                    <a-textarea v-model:value="noticeMsg" placeholder="请输入通知消息" allowClear>
                    </a-textarea>
                </a-form-item> -->

                <a-form-item label="问题图片" name="picture">
                    <upload-img-vue :attachment="formState.picture" ref="uploadImg"></upload-img-vue>
                </a-form-item>

                <a-form-item label="问题视频" name="video">
                    <upload-video-vue :attachment="formState.video" ref="uploadVideo"></upload-video-vue>
                </a-form-item>
            </template>

            <template v-else-if="modalConfig.role === 'analysis' || modalConfig.role === 'RND'">
                <a-form-item label="机身号类型" name="model">
                    <series-type-cascader type="machineOptions" placeholder="请选择机身号类型" :source="formState"
                        :target="['serialType', 'model']" :disabled="true"></series-type-cascader>
                </a-form-item>

                <a-form-item label="机身号" name="serial">
                    <a-input v-model:value="formState.serial" placeholder="请输入机身号" disabled allowClear></a-input>
                </a-form-item>

                <a-form-item label="问题现象" name="problemPhenomenon">
                    <after-sale-qeustion-vue :disabled="true" :questionLists="formState.problemPhenomenon"
                        textAreaStyle="width: 320px" ref="questionRef"></after-sale-qeustion-vue>
                </a-form-item>

                <a-form-item label="问题图片" name="picture" v-if="formState.picture && formState.picture !== '[]'">
                    <upload-img-vue :disabled="true" :attachment="formState.picture" ref="uploadImg"></upload-img-vue>
                </a-form-item>

                <a-form-item label="问题视频" name="video" v-if="formState.video && formState.video !== '[]'">
                    <upload-video-vue :disabled="true" :attachment="formState.video"
                        ref="uploadVideo"></upload-video-vue>
                </a-form-item>

                <div class="line">

                </div>
                <template
                    v-if="(modalConfig.role === 'RND' && formState.status === '无法处理') || formState.status !== '无法处理'">
                    <!-- <a-form-item v-if="">
                        <div></div>
                    </a-form-item> -->
                    <a-form-item label="通知人">
                        <staff :echoStaff="formState.recipient ? toRaw(formState).recipient : null"
                            @getChooseStaff="getChooseStaff($event, 'recipient')" :disabled="statusLimit"
                            :multiple="true"></staff>
                    </a-form-item>

                    <a-form-item label="问题类型" name="problemType">
                        <a-select :disabled="statusLimit" v-model:value="formState.problemType"
                            :options="questionTypeOptions" allowClear placeholder="请选择问题类型">
                        </a-select>
                    </a-form-item>

                    <a-form-item label="情况确认和分析" name="confirmationAndAnalysis">
                        <a-textarea :disabled="statusLimit" v-model:value="formState.confirmationAndAnalysis"
                            :auto-size="{ minRows: 1, maxRows: 10 }" placeholder="情况确认和分析" allowClear></a-textarea>
                    </a-form-item>

                    <a-form-item label="根本原因" name="rootCauseAnalysisTemplateId">
                        <a-select :options="rootCauseAnalysisOptions"
                            v-model:value="formState.rootCauseAnalysisTemplateId" :dropdownMatchSelectWidth="false"
                            @change="handleSelectRootTemplate" placeholder="请选择根本原因" allowClear>
                        </a-select>
                    </a-form-item>

                    <!-- <a-form-item label="通知消息" v-if="useNotice.recipient">
                        <a-textarea v-model:value="noticeMsg" placeholder="请输入通知消息" allowClear>

                        </a-textarea>
                    </a-form-item> -->


                    <!-- <a-form-item label="根本原因分析" name="rootCauseAnalysis">
                        <a-textarea disabled v-model:value="formState.rootCauseAnalysis"
                            :auto-size="{ minRows: 1, maxRows: 10 }" placeholder="请输入根本原因分析" allowClear></a-textarea>
                    </a-form-item> -->

                    <template v-if="formState.rootCauseAnalysisTemplateId">
                        <a-form-item label="临时措施" name="temporaryMeasures">
                            <a-textarea disabled v-model:value="formState.temporaryMeasures"
                                :auto-size="{ minRows: 1, maxRows: 10 }" placeholder="请输入临时措施" allowClear></a-textarea>
                        </a-form-item>

                        <a-form-item label="闭环措施" name="closedLoopMeasures">
                            <a-textarea disabled v-model:value="formState.closedLoopMeasures"
                                :auto-size="{ minRows: 1, maxRows: 10 }" placeholder="请输入闭环措施" allowClear></a-textarea>
                        </a-form-item>

                        <a-form-item label="确认执行" name="implementationMeasures">
                            <a-textarea disabled v-model:value="formState.implementationMeasures"
                                :auto-size="{ minRows: 1, maxRows: 10 }" placeholder="请输入确认执行" allowClear>
                            </a-textarea>
                        </a-form-item>
                    </template>
                    

                    <a-form-item label="分析部门" name="analysisDept">
                        <staff :echoStaff="toRaw(formState).analysisDept?.split(',')[0]"
                            :echostaffUserName="toRaw(formState).analysisDept?.split(',')[1]"
                            @getChooseStaff="getChooseStaff($event, 'analysisDept')" :disabled="statusLimit"
                            :appointDepartment="['工程部', '试产中心', '研发中心']"></staff>
                    </a-form-item>
                    <a-form-item label="执行部门" name="executionDept">
                        <staff :echoStaff="toRaw(formState).executionDept?.split(',')[0]"
                            :echostaffUserName="toRaw(formState).executionDept?.split(',')[1]"
                            @getChooseStaff="getChooseStaff($event, 'executionDept')" :disabled="statusLimit"
                            :appointDepartment="['生产中心', '工程部', '质量部', '客户服务部']"></staff>
                    </a-form-item>

                </template>

            </template>

            <a-form-item label="备注" name="notes">
                <a-textarea v-model:value="formState.notes" placeholder="备注" :auto-size="{ minRows: 1, maxRows: 10 }"
                    allowClear></a-textarea>
            </a-form-item>
        </a-form>
    </a-modal>
</template>

<script>
import { computed, defineComponent, reactive, ref, toRaw } from "vue";
import { useStore } from "vuex";
import { Toast, timeStampToTime, uploadMedia } from "@/utils";
import { insertAfterSaleRepair, updateAfterSaleRepair, getRootCauseAnalysisTemplateList } from '@/request/view/afterSale.js';
import { questionTypeOptions, afterSaleOptions } from './data';
import { getEngineeringDepartment } from '@/utils/base/staff.js';
import { useStaffChoice, useStaffNotice } from '@/components/chooseStaff/serve';
import websocket from "@/utils/base/socket";
import seriesTypeCascader from '@/components/cascader/index.vue';
import afterSaleQeustionVue from "@/views/repair/components/afterSaleQeustion.vue";
import uploadImgVue from "@/views/repairprogress/compoments/uploadImg.vue";
import uploadVideoVue from "@/views/repairprogress/compoments/uploadVideo.vue";
import staff from '@/components/chooseStaff/staff.vue';

export default defineComponent({
    components: { uploadImgVue, uploadVideoVue, afterSaleQeustionVue, seriesTypeCascader, staff },
    setup(props, context) {
        const formRef = ref();
        const questionRef = ref();
        const uploadImg = ref();
        const uploadVideo = ref();

        const user = useStore().state.user.user;

        const useNotice = reactive({
            recipient: false,
            analysisDept: false,
            executionDept: false,
        });

        const rootCauseAnalysisOptions = reactive([]);

        const noticeMsg = ref(null);

        const formState = reactive({
            analysisDept: null,
            closedLoopMeasures: null,
            confirmationAndAnalysis: null,
            rootCauseAnalysisTemplateId: null,
            createUserId: null,
            executionDept: null,
            feedbackDate: null,
            feedbackDept: null,
            recipient: null,
            id: null,
            model: null,
            implementationMeasures: null,
            notes: null, picture: null,
            problemPhenomenon: null,
            problemType: null,
            produceDate: null,
            rootCauseAnalysis: null,
            serial: null,
            serialType: null,
            status: null,
            supervisionDept: null,
            temporaryMeasures: null,
            video: null,
            year: null
        });

        const setAnalysisData = () => {
            getRootCauseAnalysisTemplateList().then((res) => {
                rootCauseAnalysisOptions.length = 0;
                if (res.code === 200 && res.message === '成功') {
                    res.data.forEach((item) => {
                        rootCauseAnalysisOptions.push({
                            label: item.rootCauseAnalysis,
                            value: item.id,
                            ...item
                        });
                    });
                }
            });
        };

        const afterSaleStatusLimit = computed(() => modalConfig.type === 'edit' && (formState.status !== '现场维修' && formState.status !== '设备返厂'))

        const statusLimit = computed(() => formState.status === '已完成');

        const getAfterSaleProblemDescription = () => {
            return questionRef.value.questionList.reduce((a, b) => a + `${b.value}#`, '').replace(/(.*)#/, '$1');
        };

        const handleSelectRootTemplate = (e, options) => {
            if (options) {
                Object.keys(options).forEach((key) => {
                    if (key !== 'lebel' && key !== 'id') {
                        formState[key] = options[key];
                    }
                })
            } else {
                formState.implementationMeasures = null;
                formState.rootCauseAnalysis = null;
                formState.temporaryMeasures = null;
                formState.closedLoopMeasures = null;
                formState.rootCauseAnalysisTemplateId = null;
            }
        };

        const validateProblemPhenomenon = async (rule, value) => {
            const problemDescription = getAfterSaleProblemDescription().replace(/#/g, '');
            if (problemDescription === '') {
                return Promise.reject(rule.message);
            }
            return Promise.resolve();
        };

        const rules = reactive({
            // analysisDept: [{ required: true, message: '请输入分析部门', trigger: 'change' }],
            // closedLoopMeasures: [{ required: true, message: '请输入闭环措施', trigger: 'change' }],
            problemType: [{ required: false, message: '请选择问题类型', trigger: 'change' }],
            confirmationAndAnalysis: [{ required: false, message: '请输入情况确认和分析', trigger: 'change' }],
            rootCauseAnalysisTemplateId: [{ required: false, message: '请选择根本原因分析', trigger: 'change', type: 'number' }],
            // executionDept: [{ required: true, message: '请输入执行部门', trigger: 'change' }],
            // implementationMeasures: [{ required: true, message: '请输入确认执行', trigger: 'change' }],
            problemPhenomenon: [{ required: true, message: '请输入问题现象', validator: validateProblemPhenomenon, trigger: 'change' }],
            produceDate: [{ required: true, message: '请选择生产日期', trigger: 'change' }],
            // rootCauseAnalysis: [{ required: true, message: '请输入根本原因分析', trigger: 'change' }],
            serial: [{ required: true, message: '请输入机身号', trigger: 'change' }],
            model: [{ required: true, message: '请选择设备型号', trigger: 'change' }],
            status: [{ required: true, message: '请选择状态', trigger: 'change' }],
            supervisionDept: [{ required: true, message: '请输入监督部门', trigger: 'change' }],
            // temporaryMeasures: [{ required: true, message: '请输入临时措施', trigger: 'change' }],
            year: [{ required: true, message: '请输入年度', trigger: 'change' }]
        });

        const modalConfig = reactive({
            role: null,
            visible: false,
            title: null,
            type: null,
        });

        const showModal = (type, options) => {
            const { title, data, role } = options;
            if (type === "edit" || type === 'analysis') {
                setAnalysisData();
                Object.keys(formState).forEach((key) => {
                    if (key === 'problemPhenomenon') {
                        const list = [];
                        data.problemPhenomenon.split('#').forEach((str) => {
                            list.push({
                                value: str,
                                disabled: type === 'analysis',
                            })
                        });
                        formState.problemPhenomenon = JSON.stringify(list)
                        return;
                    }
                    formState[key] = data[key];
                });
            }

            if (type === "insert") {
                formState.feedbackDate = timeStampToTime('', 'seconds');
                formState.year = String(new Date().getFullYear());
                formState.createUserId = user.id;
                formState.feedbackDept = `${user.firstLevelDepartment}${user.nickName}`;
            }

            if (formState.status === '问题分析') {
                rules.problemType[0].required = true;
                rules.confirmationAndAnalysis[0].required = true;
                rules.rootCauseAnalysisTemplateId[0].required = true;
            }

            if (type === 'analysis' && role !== 'afterSales') formState.status = '问题分析';

            modalConfig.title = title;
            modalConfig.role = role;
            modalConfig.visible = true;
            modalConfig.type = type;
        };


        const handleCancel = () => {
            resetForm();
            questionRef.value.resetList();
            modalConfig.title = null;
            modalConfig.visible = false;
            modalConfig.role = null;
            modalConfig.type = null;
            noticeMsg.value = null;
            useNotice.recipient = false;
            useNotice.analysisDept = false;
            useNotice.executionDept = false;
        };

        const resetForm = () => {
            Object.keys(formState).forEach((key) => {
                formState[key] = null;
            });
            formRef.value.clearValidate();
        };

        // websocket通知
        const websocketNotice = (toUserId, msg) => {
            if (user.id == toUserId) return;

            return websocket.Send({
                content: msg,
                query: JSON.stringify({
                    serial: formState.serial,
                    activeKey: 'afterSaleRepair',
                    type: "link",
                }),
                route: "/aftersalerepair",
                messageSort: '日常报修',
                toUserId,
                type: 0,
                userId: user.id,
            });
        };

        // 发送通知
        const handleSendMsg = () => {
            const step = {
                recipient: "处理报修信息",
                analysisDept: "确认和分析反馈问题",
                executionDept: "查收确认执行",
            };
            Object.keys(useNotice).forEach((key) => {
                if (useNotice[key]) {
                    useStaffNotice(formState[key], (staff) => {
                        const [id, username, structureName] = staff;
                        let msg = `${user.nickName}推送 日常报修 请${step[key]}`;
                        if (key === 'recipient') msg = `${msg}${noticeMsg.value ? noticeMsg.value : ""}`;
                        websocketNotice(id, msg);
                    });

                }
            });
        };

        const handleOk = () => {
            // 售后问题
            const problemPhenomenon = getAfterSaleProblemDescription();

            const payload = Object.assign({}, formState);
            payload.problemPhenomenon = problemPhenomenon;

            formRef.value
                .validateFields()
                .then(async (res) => {
                    // 上传文件
                    if (uploadImg.value && uploadVideo.value) {
                        await uploadMedia(uploadImg, uploadVideo).then((res) => {
                            payload.picture = res[0].join(',');
                            payload.video = res[1].join(',');
                        });
                    }

                    let requestFn;

                    switch (modalConfig.type) {
                        case 'insert':
                            requestFn = insertAfterSaleRepair;
                            const department = process.env.NODE_ENV === 'production' ? '试产中心' : '工程部';
                            await getEngineeringDepartment(department).then((res) => {
                                if (res) {
                                    const { id, nickName } = res;
                                    formState.recipient = `${nickName},${id.slice(1)}`;
                                    websocketNotice(id.slice(1), `${user.nickName}推送 日常报修 请处理报修信息`);
                                } else {
                                    Toast('warning', '网络问题消息通知未发送', 3);
                                }
                            });
                            break;
                        default:
                            requestFn = updateAfterSaleRepair;
                            break;
                    }

                    handleSendMsg();

                    requestFn(payload).then((res) => {
                        const type = res.code === 200 ? "success" : "warning";
                        Toast(type, res.message, 3);
                        handleCancel();
                        context.emit("handleUpdateTable");
                    });
                })
                .catch((err) => {
                    if (err && err.errorFields) {
                        const [errText] = err.errorFields[0].errors;
                        Toast("warning", errText, 3);
                    }
                });
        };

        // 选择通知人
        const getChooseStaff = (data, key) => {
            const {
                idList,
                staffUserName,
                structureName,
            } = data;

            // 兼容多选处理
            const selectValue = useStaffChoice(idList, staffUserName, structureName);
            if (!selectValue) return;

            if (selectValue === formState[key]) return;

            formState[key] = selectValue;
            useNotice[key] = true;

        };

        return {
            toRaw,
            formState,
            rules,
            formRef,
            noticeMsg,
            useNotice,
            showModal,
            handleCancel,
            handleOk,
            getChooseStaff,
            handleSelectRootTemplate,
            rootCauseAnalysisOptions,
            afterSaleStatusLimit,
            statusLimit,
            afterSaleOptions,
            questionTypeOptions,
            questionRef,
            modalConfig,
            uploadImg,
            uploadVideo,
        };
    },
});
</script>

<style lang="less" scoped>
:deep(.ant-cascader-picker-disabled) {
    color: #000;
}

.line {
    height: 2px;
    background: #ccc;
    width: 95%;
    margin-bottom: 20px;
    margin-left: 5%;
}

:deep(.ant-form-item) {
    margin-bottom: 10px;
}
</style>
